export const locale = {
  lang: 'de',
  data: {
  
    TITLE: 'डिजिटल ऑर्डर बुक',
    SORT_INFO: 'डिजिटल ऑर्डर बूक एक वेब एप्लिकेशन है जो मोबाइल एप्लिकेशन का उपयोग किए बिना वैबसाइट से मेनुफ़ेक्चररऔर डीलर्स के ऑर्डर लेती है और मेनेज करती है। डिजिटल ऑर्डर बूक एक ऑनलाइन ऑर्डर मेनेजमेंट सिस्टम है जिससे यूज़र सिंगल क्लिक करके ऑर्डर मेनेज कर सकते है।'
  
}
}
